import {Filter} from 'common/widgets/query-builder/types';
import {NumberOperator} from 'common/widgets/property-filter-menu/models/types';
import {PropertyType, ResourceType} from 'common/report/constants';
import {EventSegment} from 'common/widgets/query-block/segment-menu/types';

export const BILLING_DATA_GROUP_ID = `9292783`;
export const COMPANY_DATA_GROUP_ID = `2900955`;

export const PROPERTY_AGGREGATION = {
  label: `Number of kittens`,
  propertyDefaultType: `number`,
  resourceType: `event`,
  type: `number`,
  value: `Number of kittens`,
};

//#region Filters
export const EVENT_FILTER: Filter = {
  resourceType: ResourceType.Event,
  propertyName: `Number of kittens`,
  propertyDefaultType: PropertyType.Number,
  propertyType: PropertyType.Number,
  propertyObjectKey: null,
  filterOperator: NumberOperator.GreaterThan,
  filterValue: 1,
};

export const FIRST_TIME_EVENT_FILTER = {
  filterOperator: `nth time`,
  filterValue: null,
  propertyName: `$nth_time_event`,
  propertyObjectKey: null,
  propertyType: `other`,
  propertyDefaultType: `other`,
  resourceType: `event`,
};

export const USER_PROFILE_FILTER = {
  resourceType: `user`,
  propertyName: `number of kittens owned`,
  propertyDefaultType: `number`,
  propertyType: `number`,
  filterOperator: `is greater than`,
  filterValue: 1,
};

export const B2B_PROFILE_FILTER = {
  resourceType: `user`,
  dataGroupId: BILLING_DATA_GROUP_ID,
  propertyName: `Account Status`,
  propertyDefaultType: `string`,
  propertyType: `string`,
  filterOperator: `is set`,
  filterValue: null,
};

export const CUSTOM_PROP_FILTER = {
  customPropertyId: 2,
  resourceType: `event`,
  propertyName: `Custom Prop`,
  propertyDefaultType: `string`,
  propertyType: `string`,
  propertyObjectKey: null,
  filterOperator: `equals`,
  filterValue: [`1500`],
};

export const JOIN_KEY_FILTER = {
  resourceType: `event`,
  propertyName: `Species`,
  propertyDefaultType: `string`,
  propertyType: `string`,
  joinPropertyType: `string`,
  propertyObjectKey: null,
  filterOperator: `equals`,
  filterValue: [`1500`],
};

export const LOOKUP_PROP_FILTER = {
  resourceType: `event`,
  propertyName: [`Species`, `personality`],
  propertyDefaultType: `string`,
  propertyType: `string`,
  joinPropertyType: `string`,
  propertyObjectKey: null,
  filterOperator: `equals`,
  filterValue: [`1500`],
  dataGroupId: `7959329356733535298`,
};

export const CUSTOM_PROP_JOIN_KEY_FILTER = {
  customPropertyId: 3,
  joinPropertyType: `string`,
  filterOperator: `equals`,
  filterValue: [`1500`],
  propertyName: `Mapped Custom Prop`,
  propertyObjectKey: null,
  propertyType: `string`,
  propertyDefaultType: `string`,
  resourceType: `event`,
};

export const CUSTOM_PROP_LOOKUP_FILTER = {
  customPropertyId: 3,
  dataGroupId: `7959329356733535298`,
  joinPropertyType: `string`,
  filterOperator: `equals`,
  filterValue: [`1500`],
  propertyName: [`Mapped Custom Prop`, `size`],
  propertyObjectKey: null,
  propertyType: `string`,
  propertyDefaultType: `string`,
  resourceType: `event`,
};

export const CUSTOM_PROP_EPHEMERAL_LOOKUP_FILTER = {
  customPropertyId: 3,
  dataGroupId: `-5841623510191832133`,
  tempDataGroupId: `-5841623510191832133`,
  joinPropertyType: `string`,
  filterOperator: `equals`,
  filterValue: [`1500`],
  propertyName: [`Mapped Custom Prop`, `genus`],
  propertyObjectKey: null,
  propertyType: `string`,
  propertyDefaultType: `string`,
  resourceType: `event`,
};

export const USER_COHORT_FILTER = {
  filterOperator: `contains`,
  propertyType: `list`,
  resourceType: `cohort`,
  filterValue: [{cohort: {id: 12, name: `a saved cohort`, negated: false}}],
};

export const INLINE_USER_COHORT_FILTER = {
  ...USER_COHORT_FILTER,
  filterValue: [
    {
      cohort: {
        name: `an inline user cohort`,
        negated: false,
        raw_cohort: {name: `an inline user cohort`, selector: {}, behaviors: {}},
      },
    },
  ],
};

export const B2B_COHORT_FILTER = {
  ...USER_COHORT_FILTER,
  filterValue: [
    {cohort: {dataGroupId: BILLING_DATA_GROUP_ID, id: 14, name: `saved billing account cohort`, negated: false}},
  ],
};

export const INLINE_B2B_COHORT_FILTER = {
  ...USER_COHORT_FILTER,
  filterValue: [
    {
      cohort: {
        dataGroupId: BILLING_DATA_GROUP_ID,
        name: `inline billing account cohort`,
        negated: false,
        raw_cohort: {name: `inline billing account cohort`, selector: {}, behaviors: {}},
      },
    },
  ],
};
//#endregion

//#region Breakdowns
export const USER_SEGMENT = [
  {
    user: {
      resourceType: `user`,
      propertyName: `number of kittens owned`,
      propertyDefaultType: `number`,
      propertyType: `number`,
    },
  },
];

export const EVENT_SEGMENT: EventSegment[] = [
  {
    event: {
      resourceType: ResourceType.Event,
      propertyName: `Number of kittens`,
      propertyDefaultType: PropertyType.Number,
      propertyType: PropertyType.Number,
    },
  },
];

export const COHORT_SEGMENT = [[{cohort: {id: 1, negated: false, name: `Cohort One`}}]];

export const CUSTOM_PROP_SEGMENT: EventSegment[] = [
  {
    event: {
      resourceType: ResourceType.Event,
      propertyName: `Custom Prop`,
      propertyDefaultType: PropertyType.String,
      propertyType: PropertyType.String,
      customPropertyId: 2,
    },
  },
];

export const JOIN_KEY_SEGMENT: EventSegment[] = [
  {
    event: {
      resourceType: ResourceType.Event,
      propertyName: `Species`,
      propertyDefaultType: PropertyType.String,
      propertyType: PropertyType.String,
      joinPropertyType: PropertyType.String,
    },
  },
];

export const LOOKUP_PROP_SEGMENT: EventSegment[] = [
  {
    event: {
      resourceType: ResourceType.Event,
      propertyName: [`Species`, `personality`],
      propertyDefaultType: PropertyType.String,
      propertyType: PropertyType.String,
      joinPropertyType: PropertyType.String,
      dataGroupId: `7959329356733535298`,
    },
  },
];

export const EPHEMERAL_LOOKUP_PROP_SEGMENT: EventSegment[] = [
  {
    event: {
      resourceType: ResourceType.Event,
      propertyName: [`Species`, `family`],
      propertyDefaultType: PropertyType.String,
      propertyType: PropertyType.String,
      joinPropertyType: PropertyType.String,
      dataGroupId: `-5841623510191832133`,
      tempDataGroupId: `-5841623510191832133`,
    },
  },
];

export const CUSTOM_PROP_LOOKUP_SEGMENT: EventSegment[] = [
  {
    event: {
      resourceType: ResourceType.Event,
      propertyDefaultType: PropertyType.String,
      propertyName: [`Mapped Custom Prop`, `size`],
      propertyType: PropertyType.String,
      customPropertyId: 3,
      dataGroupId: `7959329356733535298`,
      joinPropertyType: PropertyType.String,
    },
  },
];

export const SEGMENT_WITH_CUSTOM_BUCKET = [
  {
    event: {
      resourceType: ResourceType.Event,
      propertyDefaultType: PropertyType.Number,
      propertyName: `Number of kittens`,
      propertyType: PropertyType.Number,
      customBucket: {
        bucketSize: 25,
        max: 100,
        min: 0,
        offset: null,
      },
    },
  },
];

export const B2B_PROFILE_SEGMENT = [
  {
    user: {
      resourceType: `user`,
      dataGroupId: BILLING_DATA_GROUP_ID,
      propertyName: `Account Status`,
      propertyDefaultType: `string`,
      propertyType: `string`,
    },
  },
];

export const B2B_COHORT_SEGMENT = [
  [
    {
      cohort: {dataGroupId: BILLING_DATA_GROUP_ID, id: 14, name: `saved billing account cohort`, negated: false},
    },
  ],
];

export const INLINE_B2B_COHORT_SEGMENT = [
  [
    {
      cohort: {
        dataGroupId: BILLING_DATA_GROUP_ID,
        name: `inline billing account cohort`,
        negated: false,
        raw_cohort: {name: `inline billing account cohort`, selector: {}, behaviors: {}},
      },
    },
  ],
];
//#endregion

//#region Events / entries
export const DEFAULT_EVENT = {
  aggregationOperator: `total`,
  aggregationOperatorPerUser: null,
  filtersOperator: `or`,
  property: null,
  type: `event`,
  filters: [EVENT_FILTER],
  event: {
    label: `View kittens`,
    value: `View kittens`,
  },
};

export const ANY_EVENT = {
  aggregationOperator: `total`,
  aggregationOperatorPerUser: null,
  filtersOperator: `or`,
  property: null,
  type: `event`,
  filters: [],
  event: {
    label: `Any event`,
    value: `$mp_anything_event`,
  },
};

export const ALL_USERS_ENTRY = {
  ...DEFAULT_EVENT,
  type: `user`,
  filters: [],
  readOnlyEvent: true,
  event: {
    label: `All People`,
    value: `$all_people`,
    resourceType: `cohort`,
  },
};

export const YOUR_TOP_EVENTS = {
  ...DEFAULT_EVENT,
  filters: [],
  event: {
    label: `Your Top Events`,
    value: `$top_events`,
  },
};

export const EMPTY_EVENT = {
  aggregationOperator: `total`,
  aggregationOperatorPerUser: null,
  filters: [],
  filtersOperator: `and`,
  property: null,
  type: `event`,
  event: {
    id: null,
    custom: false,
    label: ``,
    value: null,
  },
};

export const FLOWS_EVENT = {
  aggregationOperator: `total`,
  aggregationOperatorPerUser: null,
  filtersOperator: `or`,
  property: null,
  type: `flows_event`,
  filters: [EVENT_FILTER],
  event: {
    id: null,
    custom: false,
    label: `View kittens`,
    value: `View kittens`,
  },
  reverse: 1,
  forward: 2,
};

export const EVENT_WITH_B2B_FILTERS = {
  ...DEFAULT_EVENT,
  filters: [USER_PROFILE_FILTER, B2B_PROFILE_FILTER, EVENT_FILTER],
};

export const eventWithB2BFiltersSanitized = (dgid) => ({
  ...DEFAULT_EVENT,
  filters: [B2B_PROFILE_FILTER, EVENT_FILTER],
  dataGroupId: dgid,
});

export const EXCLUSION_EVENT_WITH_B2B_FILTERS = {
  ...DEFAULT_EVENT,
  filters: [USER_PROFILE_FILTER, B2B_PROFILE_FILTER, EVENT_FILTER],
  event: {id: null, custom: false, label: `Feed aardvarks`, value: `Feed aardvarks`},
  excludeRange: {},
};

export const exclusionEventWithB2BFiltersSanitized = (dgid) => ({
  ...DEFAULT_EVENT,
  filters: [B2B_PROFILE_FILTER, EVENT_FILTER],
  event: {id: null, custom: false, label: `Feed aardvarks`, value: `Feed aardvarks`},
  excludeRange: {},
  dataGroupId: dgid,
});

export const CUSTOM_EVENT_WITH_USER_FILTER = {
  event: {
    custom: true,
    id: 6,
    label: `View puppies`,
    value: `$custom_event:6`,
    can_view: true,
  },
  filters: [],
  filtersOperator: `or`,
};

export const CUSTOM_EVENT_DEFINITION_WITH_USER_FILTER = {
  name: `Custom event 1`,
  deleted: 0,
  alternatives: [
    {
      event: `Viewed report`,
      valid_segfilter: {
        filters: [
          {
            filter: {
              operator: `==`,
              operand: [`chrome`],
            },
            property: {
              source: `user`,
              type: `string`,
              name: `$browser`,
            },
            type: `string`,
            selected_property_type: `string`,
          },
        ],
        op: `and`,
      },
    },
  ],
  project_id: 3,
  id: 1,
  is_collect_everything_event: false,
  can_view: true,
};

export const BEHAVIORAL_ENTRY = {
  type: `behavior`,
  dateRange: {
    type: `in the last`,
    window: {
      unit: `day`,
      value: 7,
    },
  },
  event: CUSTOM_EVENT_WITH_USER_FILTER.event,
  filters: [
    {
      filterOperator: `equals`,
      filterValue: [`insights`],
      propertyName: `tab`,
      propertyType: `string`,
      resourceType: `event`,
      propertyDefaultType: `string`,
    },
  ],
  filtersOperator: `and`,
};

export const USER_ENTRY_WITH_BEHAVIORAL_FILTERS = {
  type: `user`,
  event: {
    resourceType: `cohort`,
    value: `$all_users`,
    label: `All Users`,
  },
  filtersOperator: `and`,
  groupingOperator: null,
  property: null,
  dataGroupId: ``,
  filters: [
    {
      customProperty: {
        name: `View puppies (with user filters) in the last 7 days`,
        behavior: BEHAVIORAL_ENTRY,
      },
      filterOperator: `is at least`,
      filterValue: 1,
      propertyType: `number`,
      resourceType: `user`,
    },
    {
      customProperty: {
        name: `View kittens in the last 7 days`,
        behavior: {
          ...BEHAVIORAL_ENTRY,
          event: DEFAULT_EVENT.event,
        },
      },
      filterOperator: `is at least`,
      filterValue: 1,
      propertyType: `number`,
      resourceType: `user`,
    },
  ],
};
//#endregion
